// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-facet .rc-autocomplete[data-v-3b05203a]{margin:1em 0}", ""]);
// Exports
module.exports = exports;
